import Navbar from '../Navigation/Navigation';
import './footer.css';
import useGetWindowSize from '../../hooks/usaGetWindowSize';

const Footer = () => {
  const { width } = useGetWindowSize();
  const isMobile = width <= 992;

  return (
    <div>
      <div className="footer">
        <div className="container">
          <div className="row logo justify-content-between">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.svg`}
              alt="Footer logo"
            />
            <div className="col-md-2 col-sm-4 col-6">
              <div className="row ">
                <span className="col-12 text-start">Charents 8a,</span>
                <span className="col-12 text-start">Nor Hachn,</span>
                <span className="col-12 text-start">2412 Kotayq,</span>
                <span className="col-12 text-start">Armenia</span>
                <span className="col-12 pt-4 text-start">
                  Tel. +37493108000
                </span>
              </div>
            </div>
          </div>
          <div className="row pt-4 justify-content-end">
            {!isMobile && (
              <div className="col-6">
                <Navbar />
              </div>
            )}
            <div className="col-md-6 col-sm-4 col-6 social justify-content-md-end">
              <a
                href="https://www.instagram.com/crystalit_diamonds/"
                target="_blank"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/instagram.svg`}
                  alt="Instagram"
                />
              </a>
              <a
                href="https://www.facebook.com/people/CrystalitCo-Diamonds-Factory/61566524648629/"
                target="_blank"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/facebook.svg`}
                  alt="Facebook"
                />
              </a>
            </div>
          </div>
          <div className="row copywrite">
            <p className="col-md-6 col-12 text-md-start text-center small">
              © Copywriting | All Rights Reserved
            </p>
            <p className="col-md-6 col-12 text-md-end text-center small">
              Terms of Use | Privacy
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
